/*! GTG nav chip Clarity + GA4 events — load once */
(function(){
  if (window.__gtgNavChipEventsBound) return;
  window.__gtgNavChipEventsBound = true;
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-gtg-nav]');
    if (!el) return;
    var nav = String(el.getAttribute('data-gtg-nav') || '').replace(/-/g, '_');
    var chip = String(el.getAttribute('data-gtg-chip') || '').replace(/-/g, '_');
    if (!nav || !chip) return;
    var clarityName = 'gtg_' + nav + '_' + chip;
    try { if (typeof window.clarity === 'function') window.clarity('event', clarityName); } catch (err) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'gtg_nav_chip', {
          nav_type: nav,
          chip: chip,
          page_path: location.pathname
        });
      }
    } catch (err) {}
  }, true);
})();
